module.exports = __webpack_public_path__ + "static/img/tawha-aublix.04985c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tawha-aublix.jpg
// module id = o9MH
// module chunks = 0